import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Copied1Icon, CopyIcon, useHapticFeedback } from '@blade/ui-kit'
import { useClipboard } from '@root/shared'

import type { WalletAddress as WalletAddress_ } from '@root/entities/wallet'

type Props = {
  address: WalletAddress_
}

export const WalletAddress: React.FC<Props> = ({ address }) => {
  const { t } = useTranslation()
  const { copyToClipboard } = useClipboard()
  const haptics = useHapticFeedback()

  const [copied, setCopied] = useState(false)

  const handleCopyAndNotify = async () => {
    haptics.impactOccurred('light')

    const isCopied = await copyToClipboard(address, {
      snackbarText: t('wallet.address_copied_snackbar'),
    })

    if (isCopied) {
      setCopied(true)
      setTimeout(() => setCopied(false), 1000)
    }
  }

  const Icon = copied ? Copied1Icon : CopyIcon

  return (
    <Root>
      <Text>{address}</Text>

      <IconWrap onClick={handleCopyAndNotify}>
        <Icon size={16} />
      </IconWrap>
    </Root>
  )
}

const Root = styled.div`
  width: auto;

  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;

  flex-shrink: 0;
`

const Text = styled.div`
  color: var(--text-11);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  overflow-x: auto;
  user-select: auto;

  &::selection {
    color: var(--text-12);
    background: var(--background-11);
  }
`

const IconWrap = styled.div`
  display: grid;
  cursor: pointer;
`
